(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-complementary-products"] && !Shopify.designMode) return;
  try {
    
  class CartComplementaryProducts extends HTMLElement {
    constructor() {
      super();
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
    }

    connectedCallback() {
      this.load();
      document.addEventListener('cart:updated', this.handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.handleCartUpdate);
    }

    get grid() {
      return this.querySelector('[data-complementary-cards]');
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get limit() {
      return Number(this.dataset.productsLimit) || 4;
    }

    get productIds() {
      try {
        return JSON.parse(this.dataset.productIds || '[]').map(String);
      } catch {
        return [];
      }
    }

    async handleCartUpdate(event) {
      const items = event.detail?.cart?.items;

      if (Array.isArray(items)) {
        this.dataset.productIds = JSON.stringify([...new Set(items.map((item) => String(item.product_id)))]);
      } else {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await response.json();
        this.dataset.productIds = JSON.stringify([...new Set(cart.items.map((item) => String(item.product_id)))]);
      }

      this.load();
    }

    recommendationUrl(productId, intent) {
      const url = new URL(`${window.Shopify.routes.root}recommendations/products`, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', String(this.limit * 2));
      url.searchParams.set('intent', intent);
      return url;
    }

    async fetchCards(productIds, intent) {
      const requests = productIds.map((productId) =>
        fetch(this.recommendationUrl(productId, intent)).then((response) => {
          if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
          return response.text();
        })
      );

      return Promise.allSettled(requests);
    }

    collectCards(responses, excludedIds, renderedIds, fragment) {
      for (const response of responses) {
        if (response.status !== 'fulfilled') continue;

        const responseDocument = new DOMParser().parseFromString(response.value, 'text/html');
        const cards = responseDocument.querySelectorAll('[data-complementary-card]');

        for (const card of cards) {
          const productId = card.dataset.productId;
          if (!productId || excludedIds.has(productId) || renderedIds.has(productId)) continue;

          renderedIds.add(productId);
          fragment.appendChild(card.cloneNode(true));

          if (renderedIds.size >= this.limit) return;
        }
      }
    }

    async load() {
      const requestId = `${Date.now()}-${Math.random()}`;
      this.requestId = requestId;
      this.classList.add('hidden');
      this.grid.replaceChildren();

      const productIds = this.productIds;
      if (!productIds.length) return;

      const excludedIds = new Set(productIds);
      const renderedIds = new Set();
      const fragment = document.createDocumentFragment();

      const complementaryResponses = await this.fetchCards(productIds, 'complementary');
      if (this.requestId !== requestId) return;

      this.collectCards(complementaryResponses, excludedIds, renderedIds, fragment);

      if (renderedIds.size < this.limit) {
        const relatedResponses = await this.fetchCards(productIds, 'related');
        if (this.requestId !== requestId) return;
        this.collectCards(relatedResponses, excludedIds, renderedIds, fragment);
      }

      this.grid.appendChild(fragment);
      this.classList.toggle('hidden', renderedIds.size === 0);
    }
  }

  if (!customElements.get('cart-complementary-products')) {
    customElements.define('cart-complementary-products', CartComplementaryProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytech-new-arrivals-tabs"] && !Shopify.designMode) return;
  try {
    
  const initializeMytechNewArrivals = (root) => {
    if (!root || root.dataset.tabsReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-tab-target]'));
    const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));

    const activateTab = (button) => {
      const target = button.dataset.tabTarget;

      buttons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== target;
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activateTab(button));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + buttons.length) % buttons.length;
        buttons[nextIndex].focus();
        activateTab(buttons[nextIndex]);
      });
    });

    root.dataset.tabsReady = 'true';
  };

  const placeMytechNewArrivals = (root) => {
    const home = document.querySelector('#mtx-v3');
    const firstProductGrid = home?.querySelector('.mtx-product-grid');
    const targetSection = firstProductGrid?.closest('.mtx-section');
    const host = root.closest('.shopify-section') || root;

    if (targetSection && host.parentElement !== targetSection.parentElement) {
      targetSection.before(host);
    }
  };

  const initializeAllMytechNewArrivals = (scope = document) => {
    scope.querySelectorAll('[data-mt-new-arrivals]').forEach((root) => {
      initializeMytechNewArrivals(root);
      placeMytechNewArrivals(root);
    });
  };

  initializeAllMytechNewArrivals();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllMytechNewArrivals(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytech-product-signature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="MyTechProduct-"]').forEach((root) => {
    const quantity = root.querySelector('input[name="quantity"]');
    const minus = root.querySelector('[data-quantity-minus]');
    const plus = root.querySelector('[data-quantity-plus]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-current-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const mobileAdd = root.querySelector('[data-mobile-add]');

    minus?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });

    plus?.addEventListener('click', () => {
      quantity.value = Number(quantity.value || 1) + 1;
    });

    variantSelect?.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      const available = selected.dataset.available === 'true';
      const hasCompare = selected.dataset.hasCompare === 'true';

      price.textContent = selected.dataset.price;
      mobilePrice.textContent = selected.dataset.price;
      comparePrice.textContent = selected.dataset.comparePrice;
      comparePrice.classList.toggle('is-hidden', !hasCompare);
      addButton.disabled = !available;
      mobileAdd.disabled = !available;
      addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      mobileAdd.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mytech-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mytech-recommendations')) {
    customElements.define(
      'mytech-recommendations',
      class MyTechRecommendations extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.url || this.querySelector('.mytech-recommendations__inner')) return;

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const wrapper = document.createElement('div');
              wrapper.innerHTML = text;
              const recommendations = wrapper.querySelector(
                `mytech-recommendations[data-section-id="${this.dataset.sectionId}"]`
              );

              if (recommendations?.querySelector('.mytech-recommendations__inner')) {
                this.innerHTML = recommendations.innerHTML;
              } else {
                this.remove();
              }
            })
            .catch(() => this.remove());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
